<div class="row contact-grid">
    <div class="col-lg-6">
        <div class="contact-wrapper">
            <form *ngIf="!submitted" (ngSubmit)="submit()" #contactForm="ngForm">
                <h1>Contact us</h1>
                <h2>Let's talk & have a coffee together</h2>
                <input type="text" class="form-control" placeholder="What's your name"
                       [(ngModel)]="contact.name" name="name" required>
                <input type="email" class="form-control" placeholder="What's your email"
                       [(ngModel)]="contact.email" name="email" required>
                <textarea placeholder="Message" required="required"
                          [(ngModel)]="contact.body" name="body"
                ></textarea>
                <span [hidden]="!error">{{ error }}</span>
                <button type="submit" class="btn-submit" [ngClass]="{'submitting': submitting}"
                        [disabled]="!contactForm.valid">
                    <i class="fa fa-angle-right" aria-hidden="true"></i>
                </button>
            </form>
            <div class="submit-message text-center" *ngIf="submitted">
                <h3>Thank you for contacting us.</h3>
                <p>You will hear from us soon!</p>
                <a routerLink="/" class="btn-primary">Go back home</a>
            </div>
        </div>
    </div>
    <div class="col-lg-6">
        <agm-map class="maps"
                 [latitude]="lat" [longitude]="lng" [zoom]="17"
                 [scrollwheel]="false">
            <agm-marker [latitude]="lat" [longitude]="lng"
                        [iconUrl]="'/assets/img/marker.png'"
            ></agm-marker>
        </agm-map>
        <div class="row">
            <div class="col-lg-12 info-card-wrapper">
                <div class="info-card">
                    <ul>
                        <li>
                            <a href="tel:0032051730083">
                                <i class="fa fa-phone" aria-hidden="true"></i>(+32) 0496 46 10 32
                            </a>
                        </li>
                        <li>
                            <a href="mailto:hi@mercit.be">
                                <i class="fa fa-comment-o" aria-hidden="true"></i>hi@mercit.be
                            </a>
                        </li>
                        <li>
                          <a href="https://www.google.be/maps/place/Driesstraat+66,+9090+Melle/@51.004531,3.7859746,17z/data=!3m1!4b1!4m5!3m4!1s0x47c375b217e23261:0x1cce0bf2495e8395!8m2!3d51.0045276!4d3.7881633" target="_blank">
                            <i class="fa fa-location-arrow" aria-hidden="true"></i>
                            Driesstraat 66, 9090 Melle
                          </a>
                        </li>
                    </ul>
                    <div class="social-links">
                      BTW BE0729 699 326
                    </div>
                </div>
            </div>

        </div>
    </div>
</div>
<div class="row bg-dark-space">
</div>



// WEBPACK FOOTER //
// /Users/tom/Projects/mercit2018/src/app/contact/contact.component.html